import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const idMatch = hash.match(/session_id=([^&]+)/);
    if (!idMatch) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(idMatch[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data?.session_token) {
          try { localStorage.setItem("session_token", data.session_token); } catch (_) {}
        }
        setUser(data?.user || null);
        // Clean fragment then go to dashboard
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: data?.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail;
        if (e?.response?.status === 403) {
          navigate("/login", { replace: true, state: { deniedReason: msg || "Access denied. Contact an administrator." } });
        } else {
          navigate("/login", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="text-sm text-neutral-500">Completing sign-in…</p>
    </div>
  );
}
